module.exports = __webpack_public_path__ + "img/hat04_uv_umb_6w.9bd39773.svg";